'use client';

import { createContext, useContext, ReactNode } from 'react';

// Define the message context type
type MessagesContextType = Record<string, unknown>;

// Create the context with a default empty object
const MessagesContext = createContext<MessagesContextType>({});

// Create a proper provider component
export function MessagesProvider({ 
  children, 
  messages 
}: { 
  children: ReactNode; 
  messages: Record<string, unknown>;
}) {
  return (
    <MessagesContext.Provider value={messages}>
      {children}
    </MessagesContext.Provider>
  );
}

// Hook to access messages - only used inside components
export function useMessages() {
  const context = useContext(MessagesContext);
  if (context === undefined) {
    throw new Error('useMessages must be used within a MessagesProvider');
  }
  return context;
}

// Translation hook - only used inside components
export function useT(section: string) {
  const messages = useMessages();
  
  return function translate(key: string) {
    try {
      const sectionMessages = messages[section] as Record<string, string>;
      return sectionMessages?.[key] || key;
    } catch {
      return key;
    }
  };
} 